import apiClient from './apiClient';

export interface ResourceRow {
  id: string;
  name: string;
  resourceCode: string;
  resourceType: 'material' | 'tool' | 'equipment' | 'supply' | 'labour';
  category?: string | null;
  unitOfMeasure: string;
  unitCost?: number | string | null;
  preferredSupplierId?: string | null;
  leadTimeDays?: number | null;
}

export interface InventorySummaryRow {
  inventoryId: string;
  resourceId: string;
  resourceCode: string;
  resourceName: string;
  resourceType: 'material' | 'tool' | 'equipment' | 'supply' | 'labour';
  category: string | null;
  unitOfMeasure: string;
  abcClassification: 'A' | 'B' | 'C' | null;
  reorderLevel: number | null;
  safetyStockLevel: number | null;
  unitCost: number | null;
  storageLocationId: string;
  storageLocationCode: string;
  storageLocationName: string;
  locationType: 'main_store' | 'site_store' | 'warehouse';
  quantityAvailable: number;
  quantityReserved: number;
  quantityInUse: number;
  totalQuantity: number;
  lowStock: boolean;
  belowSafetyStock: boolean;
  lastRestockDate: string | null;
}

export interface InventorySummaryFilters {
  resourceType?: string;
  locationId?: string;
  lowStockOnly?: boolean;
}

class ResourceService {
  async getInventorySummary(filters: InventorySummaryFilters = {}): Promise<InventorySummaryRow[]> {
    const params: Record<string, string> = {};
    if (filters.resourceType) params.resourceType = filters.resourceType;
    if (filters.locationId) params.locationId = filters.locationId;
    if (filters.lowStockOnly) params.lowStockOnly = 'true';
    const response: any = await apiClient.get('/resources/inventory-summary', { params });
    return response.data;
  }

  async createResource(input: {
    name: string;
    resourceCode?: string;
    resourceType?: ResourceRow['resourceType'];
    category?: string;
    unitOfMeasure: string;
    unitCost?: number;
    preferredSupplierId?: string;
    leadTimeDays?: number;
  }): Promise<ResourceRow> {
    const response: any = await apiClient.post('/resources', input);
    return response.data;
  }

  async updateResource(id: string, input: Partial<{
    name: string;
    resourceCode: string;
    resourceType: ResourceRow['resourceType'];
    category: string | null;
    unitOfMeasure: string;
    unitCost: number | null;
    preferredSupplierId: string | null;
    leadTimeDays: number;
  }>): Promise<ResourceRow> {
    const response: any = await apiClient.patch(`/resources/${id}`, input);
    return response.data;
  }
}

export default new ResourceService();
